import React, { useEffect, useRef } from 'react';
import { Player } from '@lottiefiles/react-lottie-player';

const LoadingScreen = () => {
  const playerRef = useRef(null);

  useEffect(() => {
    return () => {
      const player = playerRef.current;

      try {
        player?.pause?.();
        player?.stop?.();
        player?.destroy?.();
      } catch (error) {
        if (process.env.NODE_ENV === 'development') {
          console.debug('[LoadingScreen] Lottie cleanup skipped:', error);
        }
      }
    };
  }, []);

  return (
    <div
      role="status"
      aria-live="polite"
      aria-label="Loading"
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100dvh',
        gap: '20px',
      }}
    >
      <Player
        ref={playerRef}
        aria-hidden="true"
        autoplay
        loop
        src="/lotties/Loading_lottie.json"
        style={{ height: '200px', width: '200px' }}
        rendererSettings={{
          preserveAspectRatio: 'xMidYMid slice',
          clearCanvas: false,
          progressiveLoad: true,
          hideOnTransparent: true,
        }}
      />
      <p style={{ margin: 0, fontSize: '18px', color: 'var(--primary-color)' }}>Loading...</p>
    </div>
  );
};

export default LoadingScreen;
